import { render, staticRenderFns } from "./ViewSmsModal.vue?vue&type=template&id=87820986"
import script from "./ViewSmsModal.vue?vue&type=script&lang=js"
export * from "./ViewSmsModal.vue?vue&type=script&lang=js"
import style0 from "./ViewSmsModal.vue?vue&type=style&index=0&id=87820986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports